// компонент для записи в бд при регистрации пользователя (первом входе)
// также записываем имя пользователя из email в displayName, если последнее пусто.

import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { updateProfile } from "firebase/auth";
import { useHistory } from "react-router-dom";
import { PATCH } from "../Database/RealtimeDatabase";

export default function CheckUserData() {
  const { currentUser } = useAuth();
  const history = useHistory();
  if (!currentUser)  history.push("/login");

  const newName = currentUser.displayName? currentUser.displayName: currentUser.email.substring(0,currentUser.email.indexOf("@"));

  PATCH(
    //TODO: для google каждый раз обновляется дата рег. Исправить
    // 1. пишем дату регистрации в бд
    { registered: new Date().getTime() },
    "users/" + currentUser.uid
  ).then(() => {
    //2. обновляем имя пользователя если его нет
    updateProfile(currentUser, {
        displayName: newName,
      })
      .then(
        // 3. пишем имя в бд
        PATCH(
          { name: newName },
          "users/" + currentUser.uid
        ).then(() => {
          history.push("/");
        })
      )
      .catch((error) => {
        console.log(error);
      });
  });

  return <p>Проверка первого входа</p>;
}
